export   enum SSOEnum {
    Facebook = "Facebook",
    LinkedIn = "LinkedIn",
    Microsoft = "Microsoft",
    Google = "Google",
    Twitter = "Twitter"
}
